document.addEventListener('DOMContentLoaded', function () {
    console.log('sortFilter.js loaded');

    const dropdownToggle = document.querySelector('.dropdown-sort-toggle');
    const dropdownMenu = document.querySelector('.dropdown-sort-menu');
    const dropdownLabel = document.querySelector('.dropdown-sort-label');
    const arrow = dropdownToggle?.querySelector('.arrow');
    const dropdownItems = document.querySelectorAll('.dropdown-sort-item');

    console.log('dropdownToggle:', dropdownToggle);
    console.log('dropdownMenu:', dropdownMenu);

    if (!dropdownToggle || !dropdownMenu) {
        console.log('Elementi dropdown non trovati');
        return;
    }

    // Preseleziona "Prezzo crescente" di default
    const defaultItem = document.querySelector('.dropdown-sort-item[data-value="price-asc"]');
    if (defaultItem) {
        defaultItem.classList.add('active', 'fw-semibold');
    }

    // Toggle dropdown
    dropdownToggle.addEventListener('click', function (e) {
        console.log('Dropdown toggle clicked');
        e.preventDefault();
        e.stopPropagation();

        const isOpen = dropdownMenu.style.opacity === '1';
        console.log('isOpen:', isOpen);

        if (isOpen) {
            dropdownMenu.style.opacity = '0';
            dropdownMenu.style.visibility = 'hidden';
        } else {
            dropdownMenu.style.opacity = '1';
            dropdownMenu.style.visibility = 'visible';
        }

        dropdownToggle.setAttribute('aria-expanded', !isOpen);
        console.log('Menu opacity:', dropdownMenu.style.opacity);

        if (arrow) {
            arrow.classList.toggle('active');
        }
    });

    // Selezione item
    dropdownItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            // Rimuovi classe active da tutti gli item
            dropdownItems.forEach(i => i.classList.remove('active', 'fw-semibold'));

            // Aggiungi classe active all'item selezionato
            this.classList.add('active', 'fw-semibold');

            // Aggiorna il label
            const label = this.getAttribute('data-label');
            const value = this.getAttribute('data-value');

            if (dropdownLabel && label) {
                dropdownLabel.textContent = label;
            }

            // Chiudi dropdown
            dropdownMenu.style.opacity = '0';
            dropdownMenu.style.visibility = 'hidden';
            dropdownToggle.setAttribute('aria-expanded', 'false');
            if (arrow) {
                arrow.classList.remove('active');
            }

            // Qui puoi aggiungere la logica per ordinare i risultati
            console.log('Ordinamento selezionato:', value);
            // TODO: Implementare ordinamento quando sarà collegato al DB
        });
    });

    // Chiudi dropdown quando si clicca fuori
    document.addEventListener('click', function (e) {
        if (!dropdownToggle.contains(e.target)) {
            dropdownMenu.style.display = 'none';
            dropdownToggle.setAttribute('aria-expanded', 'false');
            if (arrow) {
                arrow.classList.remove('active');
            }
        }
    });
});